
















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ShipmentSearchFilters } from "../../../model/component.model";
import { isFrance } from "@/services/Helpers";
type ShipmentStatusItems = {
  name: string;
  statuses: string[] | null;
  delivered: boolean | null;
  notStatuses: string[] | null;
}[];

@Component({})
export default class ShipmentStatus extends Vue {
  @Prop()
  filters: ShipmentSearchFilters;
  shipmentStatusItem: ShipmentStatusItems = [
    {
      name: "shipment_status_pending_closure",
      statuses: ["DRAFT_TO_BE_CLOSED"],
      delivered: null,
      notStatuses: null
    },
    {
      name: "shipment_status_draft",
      statuses: ["FIRST_DRAFT_TO_BE_CLOSED"],
      delivered: null,
      notStatuses: null
    },
    {
      name: "shipment_status_processing",
      statuses: ["DRAFT_NO_WAYBILL"],
      delivered: null,
      notStatuses: null
    },
    {
      name: "shipment_status_in_transit",
      statuses: ["DRAFT_WAYBILL", "CREATED", "INVOICED"],
      delivered: null,
      notStatuses: null
    },
    {
      name: "shipment_status_delivered",
      statuses: ["CREATED", "INVOICED", "DRAFT_NO_WAYBILL", "DRAFT_WAYBILL"],
      delivered: true,
      notStatuses: null
    },
    { name: "all", statuses: null, delivered: null, notStatuses: ["OFFER"] }
  ];
  nameSelected = isFrance() ? "all" : "shipment_status_pending_closure";

  created() {
    if (this.$route.params.searchTab) {
      this.nameSelected = this.$route.params.searchTab; // set default from param if any
      this.refreshShipmentStatusFilter(
        this.shipmentStatusItem.find(value => value.name === this.nameSelected)
      );
    }
    this.$emit("onTabChange", this.nameSelected);
    this.$emit("search");
  }

  refreshShipmentStatusFilter(item: any) {
    this.nameSelected = item.name;
    this.$emit("onTabChange", this.nameSelected);
    this.filters.shipmentStatus = item.statuses ? item.statuses : null;
    this.filters.delivered = item.delivered;
    this.filters.notStatuses = item.notStatuses ? item.notStatuses : null;
  }

  isActive(item: any): boolean {
    return item.name === this.nameSelected;
  }
}
